import { getLastFileUploadFail, getUploadedFileDto } from './store/UploadSelectors'

import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import { CompanyId, FileDto } from '../../services/api.types'
import { IYumUploadProps, YumUpload } from './YumUpload'
import { deleteFile, resetUploadedFileDto, uploadImage } from './store/UploadActions'

export interface IOwnProps {
  companyId: CompanyId
  existingImageDto: FileDto | null
  updateUploadedImageDto(fileDto: FileDto | null): void
}

const mapStateToProps = (state: IGlobalState, ownProps: IOwnProps): IYumUploadProps => {
  const { companyId, existingImageDto, updateUploadedImageDto } = ownProps
  return {
    companyId,
    existingImageDto,
    updateUploadedImageDto,
    lastFileUploadFail: getLastFileUploadFail(state),
    uploadedFileDto: getUploadedFileDto(state),
  }
}

const mapDispatchToProps = {
  upload: uploadImage,
  resetUploadedFileDto,
  deleteFile,
}

export default connect(mapStateToProps, mapDispatchToProps)(YumUpload)
